var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_160_210",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_160_210)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 24,
    r: 22,
    fill: "#FBFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66928 48.6521C8.47681 48.7487 8.25601 48.5862 8.29113 48.3737L10.1494 37.1303C10.1815 36.9362 10.4072 36.8444 10.5655 36.9611L18.8919 43.0916C19.0503 43.2082 19.0297 43.451 18.8539 43.5392L8.66928 48.6521Z",
    fill: "#FBFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.9998,
    cy: 23.9998,
    r: 19.7603,
    fill: "#08D040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1693 45.3282C10.9769 45.4248 10.7561 45.2622 10.7912 45.0497L12.4445 35.0461C12.4766 34.852 12.7023 34.7603 12.8607 34.8769L20.2689 40.3315C20.4273 40.4481 20.4067 40.6908 20.2309 40.7791L11.1693 45.3282Z",
    fill: "#08D040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5822 25.4502C21.1375 23.5369 18.7547 21.2628 19.6521 20.1262C20.9394 18.5006 22.0955 17.452 19.1907 14.6009C16.2859 11.7499 14.8491 14.409 13.6051 15.983C12.1697 17.7993 14.3571 23.6059 20.9498 28.7819C27.5426 33.9579 33.721 34.7128 35.1582 32.8963C36.3991 31.3189 38.6533 29.3088 35.1964 27.1627C31.7395 25.0165 30.9858 26.3843 29.7022 28.0085C28.7991 29.1449 26.0228 27.3697 23.5822 25.4502V25.4502Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWhatsapp);
export default __webpack_public_path__ + "static/media/ico-whatsapp.d791eb3518da4de42123f33fc1bbabd5.svg";
export { ForwardRef as ReactComponent };